import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

const DpsPerson = Loadable(lazy(() => import("pages/dps/Person")));
const CombinedReport = Loadable(lazy(() => import("pages/dps/CombinedReport")));
const DpsList = Loadable(lazy(() => import("pages/dps")));
const Receipt = Loadable(lazy(() => import("pages/dps/Receipt")));
const DpsWithdraw = Loadable(lazy(() => import("pages/dps/DpsWithdraw")));
const DpsProfit = Loadable(lazy(() => import("pages/dps/DpsProfit")));

const DpsRoutes = {
  path: "dps",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "person",
      element: <DpsPerson />,
    },
    {
      path: "details/:id",
      element: <CombinedReport />,
    },
    {
      path: "list",
      element: <DpsList />,
    },
    {
      path: "receipt/:id",
      element: <Receipt />,
    },
    {
      path: "withdraw",
      element: <DpsWithdraw />,
    },
    {
      path: "profit",
      element: <DpsProfit />,
    },
  ],
};

export default DpsRoutes;
